<template>
  <div class="weui_tabbar">
    <slot></slot>
  </div>
</template>

<script>
import { parentMixin } from '../../mixins/multi-items'

export default {
  name: 'Tabbar',
  mixins: [parentMixin],
  props: {
    iconClass: String
  }
}
</script>

<style lang="less">
@import '../../styles/cui/widget/cui_tab/cui_tab_tabbar';
.weui_tabbar_icon {
  position: relative;
}
.weui_tabbar_icon > sup {
  position: absolute;
  top: -8/@w;
  left: 100%;
  transform: translateX(-50%);
  z-index: 101;
}
</style>



// WEBPACK FOOTER //
// tabbar.vue?45b1ce51